<template>
  <div class="inquiry">
    <div class="inquiry-header">
      <h2 v-if="!reports.length" class="desktop">Създаване на справка</h2>
      <h2 v-else class="desktop">Преглед на справка</h2>
      <div class="inquiry-header-controlls" ref="top">
        <span class="inquiry-pre-datepicker-text desktop">Отчетен период</span>
        <div class="inquiry-datepicker" v-show="datePeriod !== 'all'">
          <div class="new-input-wrapper">
            <div class="new-input">
              <span class="sienit">D</span>
              <input
                type="text"
                placeholder="От дата"
                @click="openDropdown(0)"
                @focus="openDropdown(0)"
                @blur="closeDropdown(0)"
                v-model="formatedFromDate"
                readonly
              />
            </div>
          </div>
          <div class="new-input-wrapper">
            <div class="new-input">
              <span class="sienit">D</span>
              <input
                type="text"
                placeholder="До дата"
                @click="openDropdown(1)"
                @focus="openDropdown(1)"
                @blur="closeDropdown(1)"
                v-model="formatedToDate"
                readonly
              />
            </div>
          </div>
          <div
            class="new-input-dropdown datepicker-dropdown"
            :class="{ 'datepicker-dropdown-active' : openedDropdown[0] }"
          >
            <datepicker
              :language="bg"
              :inline="true"
              :monday-first="true"
              :wrapper-class="'custom-datepicker'"
              :calendar-class="'custom-calendar'"
              v-model="inquiry.fromDate"
              @selected="closeDropdown(0), changeDatePeriod('none')"
            ></datepicker>
          </div>
          <div
            class="new-input-dropdown datepicker-dropdown"
            :class="{ 'datepicker-dropdown-active' : openedDropdown[1] }"
          >
            <datepicker
              :language="bg"
              :inline="true"
              :monday-first="true"
              :wrapper-class="'custom-datepicker'"
              :calendar-class="'custom-calendar'"
              v-model="inquiry.toDate"
              @selected="closeDropdown(1), changeDatePeriod('none')"
            ></datepicker>
          </div>
        </div>
        <div class="date-toggles">
          <span
            class="sienit2 date-toggle"
            :class="{ 'date-toggle-active': datePeriod === 'current' }"
            @click="changeDatePeriod('current')"
            title="Отчети за текущия месец"
          >X</span>
          <span
            class="sienit2 date-toggle"
            :class="{ 'date-toggle-active': datePeriod === 'previous'} "
            @click="changeDatePeriod('previous')"
            title="Отчети за предишния месец"
          >Z</span>
          <span
            class="sienit2 date-toggle"
            :class="{ 'date-toggle-active': datePeriod === 'half'} "
            @click="changeDatePeriod('half')"
            title="Отчети за последните 6 месеца (може да зарежда бавно)"
          >V</span>
          <span
            class="sienit2 date-toggle"
            :class="{ 'date-toggle-active': datePeriod === 'year'} "
            @click="changeDatePeriod('year')"
            title="Отчети за последната година (може да зарежда бавно)"
          >U</span>
          <span
            class="sienit2 date-toggle"
            :class="{ 'date-toggle-active': datePeriod === 'all'} "
            @click="changeDatePeriod('all')"
            title="Отчети за всички времена (може да зарежда бавно)"
          >W</span>
        </div>
      </div>
    </div>
    <div class="inquiry-filters">
      <div class="inquiry-filters-inputs">
        <!-- DESKTOP COMPANY  -->
        <div class="new-input-wrapper">
          <label>Проект</label>
          <div class="new-input">
            <span class="sienit">N</span>
            <!-- NOT SELECTED -->
            <input
              v-if="!inquiry.company._id"
              type="text"
              placeholder="Проект"
              @focus="getCompanies(), openDropdown(2)"
              @blur="closeDropdown(2)"
              v-model="searchCompanies"
            />
            <!-- SELECTED -->
            <input
              v-else
              type="text"
              placeholder="Проект"
              @focus="getCompanies(), openDropdown(2)"
              @blur="closeDropdown(2)"
              v-model="inquiry.company.companyName"
              :disabled="inquiry.company._id"
            />
            <span v-if="inquiry.company._id" class="clear" @click="resetSelectedCompany()">F</span>
          </div>
          <div
            class="new-input-dropdown"
            :class="{ 'new-input-dropdown-active' : openedDropdown[2] }"
          >
            <ul>
              <li
                v-for="c in filteredCompanies()"
                :key="c._id"
                @click="selectCompany(c)"
              >{{c.companyName}}</li>
              <!-- <li v-for="c in companies" :key="c._id">{{c.companyName}}</li> -->
            </ul>
          </div>
        </div>
        <!-- PROJECT -->
        <div class="new-input-wrapper">
          <label>Обект</label>
          <div class="new-input">
            <span class="sienit">N</span>
            <!-- NOT SELECTED -->
            <input
              v-if="!inquiry.project._id"
              type="text"
              placeholder="Обект"
              @focus="getProjects(), openDropdown(3)"
              @blur="closeDropdown(3)"
              v-model="searchProjects"
            />
            <!-- SELECTED -->
            <input
              v-else
              type="text"
              placeholder="Обект"
              @focus="getProjects(), openDropdown(3)"
              @blur="closeDropdown(3)"
              v-model="inquiry.project.projectName"
              :disabled="inquiry.project._id"
            />
            <span v-if="inquiry.project._id" class="clear" @click="resetSelectedProject()">F</span>
          </div>
          <div
            class="new-input-dropdown"
            :class="{ 'new-input-dropdown-active' : openedDropdown[3] }"
          >
            <ul>
              <li
                v-for="p in filteredProjects()"
                :key="p._id"
                @click="selectProject(p)"
              >{{p.projectName}}</li>
            </ul>
          </div>
        </div>
        <!-- ОBJECT -->
        <div class="new-input-wrapper">
          <label>Подобект</label>
          <div class="new-input">
            <span class="sienit">N</span>
            <!-- NOT SELECTED -->
            <input
              v-if="!inquiry.object._id"
              type="text"
              placeholder="Подобект"
              @focus="getObjects(), openDropdown(4)"
              @blur="closeDropdown(4)"
              v-model="searchObjects"
            />
            <!-- SELECTED -->
            <input
              v-else
              type="text"
              placeholder="Подобект"
              @focus="getObjects(), openDropdown(4)"
              @blur="closeDropdown(4)"
              v-model="inquiry.object.objectName"
              :disabled="inquiry.object._id"
            />
            <span v-if="inquiry.object._id" class="clear" @click="resetSelectedObject()">F</span>
          </div>
          <div
            class="new-input-dropdown"
            :class="{ 'new-input-dropdown-active' : openedDropdown[4] }"
          >
            <ul>
              <li
                v-for="o in filteredObjects()"
                :key="o._id"
                @click="selectObject(o)"
              >{{o.objectName}}</li>
            </ul>
          </div>
        </div>
        <!-- PART -->
        <div class="new-input-wrapper">
          <label>Част</label>
          <div class="new-input">
            <span class="sienit">N</span>
            <input
              v-if="!inquiry.part._id"
              type="text"
              placeholder="Част"
              @focus="getParts(), openDropdown(5)"
              @blur="closeDropdown(5)"
              v-model="searchParts"
            />
            <!-- SELECTED -->
            <input
              v-else
              type="text"
              placeholder="Част"
              @focus="getParts(), openDropdown(5)"
              @blur="closeDropdown(5)"
              v-model="inquiry.part.partName"
              :disabled="inquiry.part._id"
            />
            <span v-if="inquiry.part._id" class="clear" @click="resetSelectedPart()">F</span>
          </div>
          <div
            class="new-input-dropdown"
            :class="{ 'new-input-dropdown-active' : openedDropdown[5] }"
          >
            <ul>
              <li v-for="p in filteredParts()" :key="p._id" @click="selectPart(p)">{{p.partName}}</li>
            </ul>
          </div>
        </div>
        <!-- MATERIAL -->
        <div class="new-input-wrapper">
          <label>М/Д/М</label>
          <div class="new-input">
            <span class="sienit">N</span>
            <input
              type="text"
              placeholder="Материали, дейности, механизация"
              @focus="openDropdown(6), getMDM()"
              @blur="closeDropdown(6)"
              @keyup="getMDM()"
              v-model="inquiry.search"
              :disabled="isInquiryMade"
            />
            <span v-if="isInquiryMade" class="disabled">A</span>
            <span
              v-if="inquiry.search && !isInquiryMade"
              class="clear"
              @click="inquiry.search = '', resetReports()"
            >F</span>
          </div>
          <div
            class="new-input-dropdown"
            :class="{ 'new-input-dropdown-active' : openedDropdown[6] }"
          >
            <ul>
              <li v-for="(x, i) in mdm" :key="`mdm-${i}`" @click="inquiry.search = x">{{x}}</li>
            </ul>
          </div>
        </div>
        <!-- WORKER -->
        <div class="new-input-wrapper">
          <label>Изпълнител</label>
          <div class="new-input">
            <span class="sienit">N</span>
            <input
              v-if="!inquiry.worker._id"
              type="text"
              placeholder="Изпълнител"
              @focus="getWorkers(), openDropdown(7)"
              @blur="closeDropdown(7)"
              v-model="searchWorkers"
              :disabled="inquiry.reporter._id.length > 0"
            />
            <!-- SELECTED -->
            <input
              v-else
              type="text"
              placeholder="Изпълнител"
              @focus="getWorkers(), openDropdown(7)"
              @blur="closeDropdown(7)"
              v-model="inquiry.worker.name"
              :disabled="inquiry.reporter._id.length > 0 || inquiry.worker._id"
            />
            <span v-if="inquiry.worker._id" class="clear" @click="resetSelectedWorker()">F</span>
            <span v-if="inquiry.reporter._id.length > 0" class="disabled">A</span>
          </div>
          <div
            class="new-input-dropdown"
            :class="{ 'new-input-dropdown-active' : openedDropdown[7] }"
          >
            <ul>
              <li v-for="w in filteredWorkers()" :key="w._id" @click="selectWorker(w)">{{w.name}}</li>
            </ul>
          </div>
        </div>
                <!-- DEKTOP REPORTER -->
        <div class="new-input-wrapper">
          <label>Отчетник</label>
          <div class="new-input">
            <span class="sienit">N</span>
            <input
              v-if="!inquiry.reporter._id"
              type="text"
              placeholder="Отчетник"
              @focus="getReporters(), openDropdown(8)"
              @blur="closeDropdown(8)"
              v-model="searchReporters"
              :disabled="inquiry.worker._id.length > 0"
            >
            <input
              v-else
              type="text"
              placeholder="Отчетник"
              @focus="getReporters(), openDropdown(8)"
              @blur="closeDropdown(8)"
              v-model="inquiry.reporter.name"
              :disabled="inquiry.worker._id.length > 0 || inquiry.reporter._id"
            >
            <span
              v-if="inquiry.reporter._id && getUser.permissions.isAdmin"
              class="clear"
              @click="resetSelectedReporter()"
            >F</span>
            <span
              v-if="inquiry.worker._id.length > 0 || (!getUser.permissions.isAdmin && getUser.permissions.isReporter)"
              class="disabled"
            >A</span>
          </div>
          <div
            class="new-input-dropdown"
            :class="{ 'new-input-dropdown-active' : openedDropdown[8] }"
          >
            <ul>
              <li
                v-for="r in filteredReporters()"
                :key="r._id"
                @click="selectReporter(r)"
              >{{r.name}}</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="inquiry-filters-btns">
        <div class="flag-toggles">
          <p>Въведени суми</p>
          <div
            class="flag-toggle"
            :class="{ 'flag-toggle-active' : inquiry.priceStatus === 0 }"
            @click="selectPriceStatus(0)"
          >
            <img
              class="flag-indicator"
              src="../assets/img/red.svg"
              alt="Няма въведени цени"
              title="Няма въведени цени"
            />
          </div>
          <div
            class="flag-toggle"
            :class="{ 'flag-toggle-active' : inquiry.priceStatus === 1 }"
            @click="selectPriceStatus(1)"
          >
            <img
              class="flag-indicator"
              src="../assets/img/yellow.svg"
              alt="Има невъведени цени"
              title="Има невъведени цени"
            />
          </div>
          <div
            class="flag-toggle"
            :class="{ 'flag-toggle-active' : inquiry.priceStatus === 2 }"
            @click="selectPriceStatus(2)"
          >
            <img
              class="flag-indicator"
              src="../assets/img/green.svg"
              alt="Всички цени са въведени"
              title="Всички цени са въведени"
            />
          </div>
        </div>
        <div class="checkboxes-wrapper">
          <label class="checkbox-wrapper">
            Активни подобекти
            <input
              type="checkbox"
              v-model="activeProjects"
              @change="selectActiveProjects()"
            />
            <span class="checkmark"></span>
          </label>
          <label class="checkbox-wrapper">
            Грешни отчети
            <input
              type="checkbox"
              v-model="inquiry.isInvalid"
              @change="selectInvalid()"
            />
            <span class="checkmark"></span>
          </label>
        </div>
        <!-- DESKTOP BUTTONS -->
        <button v-if="!reports.length" class="btn btn-new" @click="checkPeriod()">Направи справка</button>
        <div v-else class="btns desktop">
          <!-- @click="exportFile()" -->
          <button class="btn btn-excel" @click="exportToExcelFile()">
            <span class="sienit">E</span>
            Експорт в Excel
          </button>
          <button class="btn btn-reset" @click="resetInquiry()">
            <span class="sienit">F</span>
            Нулирай филтри
          </button>
        </div>
      </div>
    </div>
    <div class="inquiry-title-wrapper" v-if="isInquiryMade">
      <h3 class="inquiry-title" :class="{ 'inquiry-title-invalid': !activeProjects }" ref="reports">
        <span>Справка&nbsp;</span>
        <span v-if="inquiry.company._id">
          <span>за фроект&nbsp;</span>
          <strong>{{inquiry.company.companyName}}&nbsp;</strong>
        </span>
        <span v-else>
          <span>
            по
            <template v-if="inquiry.isInvalid">грешни&nbsp;</template>отчети за&nbsp;
          </span>
          <strong>
            всички
            <template v-if="!activeProjects">неактивни&nbsp;</template>проекти&nbsp;
          </strong>
        </span>
        <span v-if="inquiry.project._id">
          <span>обект&nbsp;</span>
          <strong>{{inquiry.project.projectName}}&nbsp;</strong>
        </span>
        <span v-if="inquiry.object._id">
          <span>подобект&nbsp;</span>
          <strong>{{inquiry.object.objectName}}&nbsp;</strong>
        </span>
        <span v-if="inquiry.part._id">
          <span>част&nbsp;</span>
          <strong>{{inquiry.part.partName}}&nbsp;</strong>
        </span>
        <span v-if="inquiry.reporter._id">
          <span>отчетник&nbsp;</span>
          <strong>{{inquiry.reporter.name}}&nbsp;</strong>
        </span>
        <span v-if="inquiry.worker._id">
          <span>изпълнител&nbsp;</span>
          <strong>{{inquiry.worker.name}}&nbsp;</strong>
        </span>
        <span v-if="inquiry.priceStatus === 0">
          <strong>без въведени суми</strong>
        </span>
        <span v-if="inquiry.priceStatus === 1">
          <strong>с липсващи суми</strong>
        </span>
        <span v-if="inquiry.priceStatus === 2">
          <strong>с всички въведени суми</strong>
        </span>
      </h3>
      <h3
        class="inquiry-title"
        v-if="inquiry.search"
        :class="{ 'inquiry-title-invalid': !activeProjects }"
      >
        с приложен филтър по М/Д/М -
        <strong>{{inquiry.search}}</strong>
      </h3>
      <h3 class="inquiry-title" :class="{ 'inquiry-title-invalid': !activeProjects }">
        <template v-if="datePeriod !== 'all'">
          <span>за периода - от&nbsp;</span>
          <strong>{{formatedFromDate}}</strong>
          <span>&nbsp;до&nbsp;</span>
          <strong>{{formatedToDate}}</strong>
        </template>
        <template v-else>
          <span>
            за
            <strong>всички времена</strong>
          </span>
        </template>
      </h3>
    </div>
    <div v-if="!isInquiryMade" class="no-reports">
      <p>Изберете филтри и натиснете бутона - "Направи справка"</p>
    </div>
    <div class="no-reports" v-if="isInquiryMade && !reports.length && !getLoading" ref="no-reports">
      <p>Няма добавени отчети за избраните параметри.</p>
    </div>
    <div class="no-reports" v-if="getLoading">
      <p>Моля изчакайте, резултатите се зареждат...</p>
      <img class="loading" src="../assets/img/loading_dark.svg" alt="loading" />
    </div>
    <div class="reports" v-if="reports.length">
      <div class="reports-tabs">
        <button
          class="reports-tab"
          :class="{ 'reports-tab-active' : activeTab === 0 }"
          @click="selectTab(0)"
        >
          <span>Отчети</span>
          <span v-if="!this.inquiry.worker._id">({{reports.length}})</span>
        </button>
        <button
          class="reports-tab"
          :class="{ 'reports-tab-active' : activeTab === 1 }"
          @click="selectTab(1)"
        >
          <span>Материали</span>
          <span v-if="!this.inquiry.worker._id">({{totalMaterialQuantity}})</span>
        </button>
        <!-- Temporarily disabled: the new diary no longer uses the old activity tab. -->
        <!-- <button
          class="reports-tab"
          :class="{ 'reports-tab-active' : activeTab === 2 }"
          @click="selectTab(2)"
        >
          <span>Дейности</span>
          <span v-if="!this.inquiry.worker._id">({{totalActivityQuantity}})</span>
        </button> -->
        <!-- Temporarily disabled: the new diary no longer uses the old mechanization tab. -->
        <!-- <button
          class="reports-tab"
          :class="{ 'reports-tab-active' : activeTab === 3 }"
          @click="selectTab(3)"
        >
          <span>Механизации</span>
          <span v-if="!this.inquiry.worker._id">({{totalMechanizationQuantity}})</span>
        </button> -->
        <button
          class="reports-tab"
          :class="{ 'reports-tab-active' : activeTab === 4 }"
          @click="selectTab(4)"
        >
          <span>Изпълнители</span>
          <span>({{totalWorkersItems}})</span>
        </button>
      </div>
      <div class="reports-content">
        <!-- REPORTS -->
        <div class="table-wrapper">
          <table class="table" ref="reportsTable" v-show="activeTab === 0">
            <thead>
              <tr>
                <th>Дата</th>
                <th>Отчетник</th>
                <th>Проект</th>
                <th>Обект</th>
                <th>Подобект</th>
                <th>Част</th>
                <!-- <th class="center">Отчетени<br>&nbsp;хора&nbsp;</th>
                <th class="center">Общо отчетено<br>&nbsp;време&nbsp;</th>-->
                <th class="center">Отчетено</th>
                <th>Списък отчетено</th>
                <th v-if="getUser.permissions.isSuperAdmin || getUser.permissions.isAdmin"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="r in reports"
                :key="`report-${r._id}`"
                @click="goToReport(r._id)"
                :class="{ 'tr-invalid': r.isInvalid }"
              >
                <td>
                  <span class="no-wrap">{{r.date | formatDate}} г.</span>
                </td>
                <td>
                  <span>{{r.createdBy.name}}</span>
                </td>
                <td class="td-company-name">
                  <img
                    class="td-invalid-flag"
                    v-if="r.isInvalid"
                    src="../assets/img/flag_yes.svg"
                    alt="invalid"
                  />
                  {{r.company.companyName}}
                </td>
                <td>{{r.project.projectName}}</td>
                <td>{{r.object.objectName}}</td>
                <td>
                  <span v-if="r.part">{{r.part.partName}}</span>
                </td>
                <!-- <td class="center"> -->
                <!-- {{report.workers.length}} -->
                <!-- </td> -->
                <!-- <td class="center"> -->
                <!-- Look here -->
                <!-- <div class="worktime-indicator-wrapper">
                    <p
                      v-if="calculateHours(report.date, report.startHour, report.endHour).normal * report.workers.length"
                    >
                      <span class="worktime-indicator">НРВ</span>
                      {{calculateHours(report.date, report.startHour, report.endHour).normal * report.workers.length}} ч.
                    </p>
                    <p
                      v-if="calculateHours(report.date, report.startHour, report.endHour).overtime * report.workers.length"
                    >
                      <span class="worktime-indicator overtime-indicator">ИРВ 1</span>
                      {{calculateHours(report.date, report.startHour, report.endHour).overtime * report.workers.length}} ч.
                    </p>
                    <p
                      v-if="calculateHours(report.date, report.startHour, report.endHour).holiday * report.workers.length"
                    >
                      <span class="worktime-indicator holiday-indicator">ИРВ 2</span>
                      {{calculateHours(report.date, report.startHour, report.endHour).holiday * report.workers.length}} ч.
                    </p>
                </div>-->
                <!-- </td> -->
                <td class="center">
                  {{diaryRows(r, 'buildingMaterials').length}}
                </td>
                <td>{{reportedItems(r)}}</td>
                <td v-if="getUser.permissions.isSuperAdmin || getUser.permissions.isAdmin">
                  <img
                    class="flag-indicator"
                    v-if="r.priceStatus === 2"
                    src="../assets/img/green.svg"
                    alt="Всички цени са въведени"
                    title="Всички цени са въведени"
                  />
                  <img
                    class="flag-indicator"
                    v-else-if="r.priceStatus === 1"
                    src="../assets/img/yellow.svg"
                    alt="Има невъведени цени"
                    title="Има невъведени цени"
                  />
                  <img
                    class="flag-indicator"
                    v-else-if="r.priceStatus === 0"
                    src="../assets/img/red.svg"
                    alt="Няма въведени цени"
                    title="Няма въведени цени"
                  />
                </td>
              </tr>
              <tr v-if="isInquiryMade && !reports.length">
                <td :colspan="reportsColumnCount" class="td-center">Няма добавени отчети за избраните параметри.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- MATERIALS -->
        <div class="table-wrapper">
          <table class="table" ref="materials" v-show="activeTab === 1">
            <thead>
              <tr>
                <th>Дата</th>
                <th>Отчетник</th>
                <th>Материал</th>
                <th>Чрез документ</th>
                <th>Мерна единица</th>
                <th>Вложено количество</th>
                <th>Върнат материал в склад</th>
                <th>Материали за друг обект</th>
                <th>Забележка</th>
                <th v-if="getUser.permissions.isSuperAdmin || getUser.permissions.isAdmin">
                  Цена (евро)
                </th>
                <th v-if="getUser.permissions.isSuperAdmin || getUser.permissions.isAdmin">
                  Обща сума (евро)
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="r in reports">
                <tr
                  v-for="(m, i) in diaryRows(r, 'buildingMaterials')"
                  :key="`r-${r._id}-ma-${i}`"
                  @click="goToReport(r._id)"
                  :class="{ 'tr-invalid': r.isInvalid }"
                >
                  <td>
                    <span class="no-wrap">{{r.date | formatDate}} г.</span>
                  </td>
                  <td>{{r.createdBy.name}}</td>
                  <td>{{m.name}}</td>
                  <td>{{m.documentNumber}}</td>
                  <td>{{m.unit}}</td>
                  <td>{{m.incomingQuantity}}</td>
                  <td>{{m.source}}</td>
                  <td>{{m.place}}</td>
                  <td>{{m.note}}</td>
                  <td
                    v-if="getUser.permissions.isSuperAdmin || getUser.permissions.isAdmin"
                  >{{m.price}}</td>
                  <td
                    v-if="getUser.permissions.isSuperAdmin || getUser.permissions.isAdmin"
                  >{{materialTotal(m).toFixed(2)}}</td>
                </tr>
              </template>
              <tr v-if="isInquiryMade && !totalMaterialQuantity">
                <td :colspan="materialsColumnCount" class="td-center">Няма добавени материали за избраните параметри.</td>
              </tr>
              <tr
                class="sum-row"
                v-if="getUser.permissions.isSuperAdmin || getUser.permissions.isAdmin"
              >
                <td :colspan="materialsColumnCount - 1">Обща сума за избраните материали (евро):</td>
                <td>{{totalMaterials.toFixed(2)}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- ACTIVITIES -->
        <!-- Temporarily disabled with its tab; kept until the legacy view is removed. -->
        <div v-if="false" class="table-wrapper">
          <table class="table" ref="activities" v-show="activeTab === 2">
            <thead>
              <tr>
                <th>Дата</th>
                <th>Отчетник</th>
                <th>Дейност</th>
                <th>Изпълнител</th>
                <th>Тип документ</th>
                <th>Номер документ</th>
                <th>Сума по документ (евро)</th>
                <th>Количество</th>
                <th>
                  Мерна&nbsp;
                  <br />единица
                </th>
                <th v-if="getUser.permissions.isSuperAdmin || getUser.permissions.isAdmin">
                  Обща&nbsp;
                  <br />цена в евро
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="r in reports">
                <tr
                  v-for="(a, i) in r.activities"
                  :key="`r-${r._id}-a-${a._id}-${i}`"
                  @click="goToReport(r._id)"
                  :class="{ 'tr-invalid': r.isInvalid}"
                >
                  <td>
                    <span class="no-wrap">{{r.date | formatDate}} г.</span>
                  </td>
                  <td>{{r.createdBy.name}}</td>
                  <td>{{a.name}}</td>
                  <td>
                    <template v-if="a.worker">{{a.worker.name}}</template>
                  </td>
                  <td>
                    <template v-if="a.document">{{a.document.type}}</template>
                  </td>
                  <td>
                    <template v-if="a.document">{{a.document.number}}</template>
                  </td>
                  <td>
                    <template v-if="a.document">{{a.document.sum}}</template>
                  </td>
                  <td>{{a.quantity}}</td>
                  <td>{{a.unit}}</td>
                  <td
                    v-if="getUser.permissions.isSuperAdmin || getUser.permissions.isAdmin"
                  >{{(+a.price * +a.quantity).toFixed(2)}}</td>
                </tr>
              </template>
              <tr v-if="isInquiryMade && !totalActivityQuantity">
                <td colspan="10" class="td-center">Няма извършени дейности за избраните параметри.</td>
              </tr>
              <tr
                class="sum-row"
                v-if="getUser.permissions.isSuperAdmin || getUser.permissions.isAdmin"
              >
                <td colspan="9">Обща сума за избраните дейности (евро):</td>
                <td>{{totalActivities.toFixed(2)}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- MECHANIZATIONS -->
        <!-- Temporarily disabled with its tab; kept until the legacy view is removed. -->
        <div v-if="false" class="table-wrapper">
          <table class="table" ref="mechanizations" v-show="activeTab === 3">
            <thead>
              <tr>
                <th>Дата</th>
                <th>Отчетник</th>
                <th>Механицация</th>
                <th>Изпълнител</th>
                <th>Тип документ</th>
                <th>Номер документ</th>
                <th>Сума по документ (евро)</th>
                <th>Количество</th>
                <th>
                  Мерна&nbsp;
                  <br />единица
                </th>
                <th v-if="getUser.permissions.isSuperAdmin || getUser.permissions.isAdmin">
                  Обща&nbsp;
                  <br />цена в евро
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="r in reports">
                <tr
                  v-for="(m, i) in r.mechanizations"
                  :key="`report-${r._id}-me-${m._id}-${i}`"
                  @click="goToReport(r._id)"
                  :class="{ 'tr-invalid': r.isInvalid}"
                >
                  <td>
                    <span class="no-wrap">{{r.date | formatDate}} г.</span>
                  </td>
                  <td>{{r.createdBy.name}}</td>
                  <td>{{m.name}}</td>
                  <td>
                    <template v-if="m.worker">{{m.worker.name}}</template>
                  </td>
                  <td>
                    <template v-if="m.document">{{m.document.type}}</template>
                  </td>
                  <td>
                    <template v-if="m.document">{{m.document.number}}</template>
                  </td>
                  <td>
                    <template v-if="m.document">{{m.document.sum}}</template>
                  </td>
                  <td>{{m.quantity}}</td>
                  <td>{{m.unit}}</td>
                  <td
                    v-if="getUser.permissions.isSuperAdmin || getUser.permissions.isAdmin"
                  >{{(+m.price * +m.quantity).toFixed(2)}}</td>
                </tr>
              </template>
              <tr v-if="isInquiryMade && !totalMechanizationQuantity">
                <td
                  colspan="10"
                  class="td-center"
                >Няма извършени механизации за избраните параметри.</td>
              </tr>
              <tr
                class="sum-row"
                v-if="getUser.permissions.isSuperAdmin || getUser.permissions.isAdmin"
              >
                <td colspan="9">Обща сума за избраните механизации (евро):</td>
                <td>{{totalMechanizations.toFixed(2)}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- WORKERS -->
        <div class="table-wrapper">
          <table class="table" ref="workers" v-show="activeTab === 4">
            <thead>
              <tr>
                <th>Дата</th>
                <th>Отчетник</th>
                <th>СМР тип</th>
                <th>СМР име</th>
                <th>Изпълнител</th>
                <th>Количество</th>
                <th>
                  Мерна&nbsp;
                  <br />единица
                </th>
                <th v-if="getUser.permissions.isSuperAdmin || getUser.permissions.isAdmin">
                  Обща&nbsp;
                  <br />цена в евро
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="r in reports">
                <template v-for="(m, i) in r.materials">
                  <tr
                    v-if="m.worker"
                    :key="`workers-${r._id}-mat-${m._id}-${i}`"
                    @click="goToReport(r._id)"
                    :class="{ 'tr-invalid': r.isInvalid}"
                  >
                    <td>
                      <span class="no-wrap">{{r.date | formatDate}} г.</span>
                    </td>
                    <td>{{r.createdBy.name}}</td>
                    <td>Материали</td>
                    <td>{{m.name}}</td>
                    <td>
                      <p v-if="m.worker">{{m.worker.name}}</p>
                    </td>
                    <td>{{m.quantity}}</td>
                    <td>{{m.unit}}</td>
                    <td
                      v-if="getUser.permissions.isSuperAdmin || getUser.permissions.isAdmin"
                    >{{(+m.price * +m.quantity).toFixed(2)}}</td>
                  </tr>
                </template>
                <template v-for="(a, i) in r.activities">
                  <tr
                    v-if="a.worker"
                    :key="`workers-${r._id}-a-${a._id}-${i}`"
                    @click="goToReport(r._id)"
                    :class="{ 'tr-invalid': r.isInvalid}"
                  >
                    <td>
                      <span class="no-wrap">{{r.date | formatDate}} г.</span>
                    </td>
                    <td>{{r.createdBy.name}}</td>
                    <td>Дейности</td>
                    <td>{{a.name}}</td>
                    <td>
                      <p v-if="a.worker">{{a.worker.name}}</p>
                    </td>
                    <td>{{a.quantity}}</td>
                    <td>{{a.unit}}</td>
                    <td
                      v-if="getUser.permissions.isSuperAdmin || getUser.permissions.isAdmin"
                    >{{(+a.price * +a.quantity).toFixed(2)}}</td>
                  </tr>
                </template>
                <template v-for="(m, i) in r.mechanizations">
                  <tr
                    v-if="m.worker"
                    :key="`workers-${r._id}-me-${m._id}-${i}`"
                    @click="goToReport(r._id)"
                    :class="{ 'tr-invalid': r.isInvalid}"
                  >
                    <td>
                      <span class="no-wrap">{{r.date | formatDate}} г.</span>
                    </td>
                    <td>{{r.createdBy.name}}</td>
                    <td>Механизации</td>
                    <td>{{m.name}}</td>
                    <td>
                      <p v-if="m.worker">{{m.worker.name}}</p>
                    </td>
                    <td>{{m.quantity}}</td>
                    <td>{{m.unit}}</td>
                    <td
                      v-if="getUser.permissions.isSuperAdmin || getUser.permissions.isAdmin"
                    >{{(+m.price * +m.quantity).toFixed(2)}}</td>
                  </tr>
                </template>
              </template>
              <tr
                v-if="isInquiryMade && !totalMaterialQuantity && !totalActivityQuantity && !totalMechanizationQuantity"
              >
                <td colspan="8" class="td-center">Няма добавени изпълнители към никое СМР.</td>
              </tr>
              <tr
                class="sum-row"
                v-if="getUser.permissions.isSuperAdmin || getUser.permissions.isAdmin"
              >
                <td colspan="7">Обща сума за избраните изпълнители (евро):</td>
                <td>{{totalWorkers.toFixed(2)}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- MOBILE BUTTONS -->
    <footer class="modal-footer mobile" v-if="reports.length" ref="footer">
      <div class="btns mobile">
        <!-- UP -->
        <span class="new-content-data-item-toggle-circle mobile top" @click="scrollToTop()">
          <span class="sienit">f</span>
        </span>
        <!-- NEW Inquiry -->
        <span class="new-content-data-item-toggle-circle mobile" @click="resetInquiry()">
          <span class="sienit">L</span>
        </span>
        <!-- EXPORT IN EXCEL -->
        <span class="new-content-data-item-toggle-circle mobile excel" @click="exportToExcelFile()">
          <span class="sienit">E</span>
        </span>
      </div>
    </footer>
  </div>
</template>

<script>
import hours from './mixins/hours.js';
import Datepicker from 'vuejs-datepicker';
import { bg } from 'vuejs-datepicker/dist/locale';
import XLSX from 'xlsx';
import { mapGetters } from 'vuex';
export default {
  components: {
    Datepicker
  },
  mixins: [hours],
  data() {
    return {
      // Vars for select v-model
      company: '',
      project: '',
      object: '',
      part: '',
      reporter: '',
      worker: '',
      // Scroll checker
      isScrolled: false,
      bg: bg,
      formatedFromDate: null,
      formatedToDate: null,
      activeTab: 0,
      datePeriod: 'current',
      // DROPDOWNS
      openedDropdown: [false, false, false, false, false, false, false, false, false],
      // SEARCH
      searchCompanies: '',
      searchProjects: '',
      searchObjects: '',
      searchParts: '',
      searchReporters: '',
      searchWorkers: '',
      companies: [],
      projects: [],
      objects: [],
      parts: [],
      reporters: [],
      workers: [],
      reports: [],
      mdm: [],
      totalMaterials: 0,
      totalActivities: 0,
      totalMechanizations: 0,
      totalWorkers: 0,
      totalMaterialQuantity: 0,
      totalActivityQuantity: 0,
      totalMechanizationQuantity: 0,
      totalWorkersItems: 0,
      isInquiryMade: false,
      queryObject: {},
      activeProjects: true,
      inquiry: {
        fromDate: '',
        toDate: '',
        company: {
          _id: '',
          companyName: ''
        },
        project: {
          _id: '',
          projectName: ''
        },
        object: {
          _id: '',
          objectName: ''
        },
        part: {
          _id: '',
          partName: ''
        },
        reporter: {
          _id: '',
          name: ''
        },
        worker: {
          _id: '',
          name: ''
        },
        isInvalid: false,
        priceStatus: null,
        search: ''
      }
    };
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      'getUser',
      'getLoading'
      // ...
    ]),
    showPriceStatus() {
      const permissions = this.getUser && this.getUser.permissions;
      return Boolean(
        permissions && (permissions.isSuperAdmin || permissions.isAdmin)
      );
    },
    reportsColumnCount() {
      return 8 + (this.showPriceStatus ? 1 : 0);
    },
    materialsColumnCount() {
      return 9 + (this.showPriceStatus ? 2 : 0);
    }
  },
  watch: {
    'inquiry.fromDate'(to, from) {
      // eslint-disable-next-line
      if (!!from) {
        this.resetReports();
      }
      this.inquiry.fromDate.setHours(0, 0, 0, 0);
      this.queryObject.fromDate = this.inquiry.fromDate.toISOString();
      this.formatedFromDate = this.$moment(
        String(this.inquiry.fromDate.toISOString())
      ).format('DD/MM/YYYY');
    },
    'inquiry.toDate'(to, from) {
      // eslint-disable-next-line
      if (!!from) {
        this.resetReports();
      }
      this.inquiry.toDate.setHours(23, 59, 59, 999);
      this.queryObject.toDate = this.inquiry.toDate.toISOString();
      this.formatedToDate = this.$moment(
        String(this.inquiry.toDate.toISOString())
      ).format('DD/MM/YYYY');
    }
  },
  methods: {
    changeDatePeriod(p) {
      this.datePeriod = p;
      if (p === 'current') {
        this.setDates(0, -1);
      } else if (p === 'previous') {
        this.setDates(1, 0);
      } else if (p === 'half') {
        this.setDates(6, -1);
      } else if (p === 'year') {
        this.setDates(12, -1);
      } else if (p === 'all') {
        this.setDates(12000, -12000);
      }
      this.queryObject.period = p;
      this.$router.push({ query: this.queryObject });
    },
    selectPriceStatus(p) {
      this.resetReports();
      if (p === this.inquiry.priceStatus) {
        this.inquiry.priceStatus = null;
      } else {
        this.inquiry.priceStatus = p;
      }
      this.queryObject.status = p;
      this.$router.push({ query: this.queryObject });
    },
    exportToExcelFile() {
      const wscols = Array.from(
        { length: this.materialsColumnCount },
        () => ({ wpx: 100 })
      );

      const config = { dateNF: 'dd/mm/yyyy' };
      // Convert Table to Worksheet

      if (!this.inquiry.worker._id) {
        const reportsWorksheet = XLSX.utils.table_to_sheet(
          this.$refs['reportsTable'],
          config
        );
        const materialsWorksheet = XLSX.utils.table_to_sheet(
          this.$refs['materials'],
          config
        );
        const workersWorksheet = XLSX.utils.table_to_sheet(
          this.$refs['workers'],
          config
        );
        // Define New Workbook
        const new_workbook = XLSX.utils.book_new();

        reportsWorksheet['!cols'] = wscols;
        materialsWorksheet['!cols'] = wscols;
        workersWorksheet['!cols'] = wscols;

        // Append Worksheet
        XLSX.utils.book_append_sheet(new_workbook, reportsWorksheet, 'Отчети');
        XLSX.utils.book_append_sheet(
          new_workbook,
          materialsWorksheet,
          'Материали'
        );
        XLSX.utils.book_append_sheet(
          new_workbook,
          workersWorksheet,
          'Изпълнители'
        );
        // Save File
        XLSX.writeFile(
          new_workbook,
          `Справка-${this.formatedFromDate}-${this.formatedToDate}.xlsx`
        );
      } else {
        const workersWorksheet = XLSX.utils.table_to_sheet(
          this.$refs['workers'],
          config
        );
        // Define New Workbook
        const new_workbook = XLSX.utils.book_new();

        workersWorksheet['!cols'] = wscols;

        // Append Worksheet
        XLSX.utils.book_append_sheet(
          new_workbook,
          workersWorksheet,
          'Изпълнители'
        );
        // Save File

        XLSX.writeFile(
          new_workbook,
          `Справка-за-${this.inquiry.worker.name}-${this.formatedFromDate}-${this.formatedToDate}.xlsx`
        );
      }
    },
    // Open dropdown. Depends on index (hard coded in template)
    openDropdown(i) {
      this.$set(this.openedDropdown, i, true);
    },
    // Close dropdown. Depends on index (hard coded in template)
    closeDropdown(i) {
      setTimeout(() => {
        this.$set(this.openedDropdown, i, false);
      }, 100);
    },
    selectTab(num) {
      if (this.inquiry.worker._id) {
        this.activeTab = 4;
      } else {
        this.activeTab = [0, 1, 4].includes(num) ? num : 0;
      }
      this.queryObject.tab = this.activeTab;
      this.$router.push({ query: this.queryObject });
    },
    diaryRows(report, sectionKey) {
      return report.diary && Array.isArray(report.diary[sectionKey])
        ? report.diary[sectionKey]
        : [];
    },
    reportedItems(report) {
      return this.diaryRows(report, 'buildingMaterials')
        .map(row => row.name)
        .filter(Boolean)
        .join(', ');
    },
    materialTotal(material) {
      const price = Number(material.price);
      const quantity = Number(material.incomingQuantity);
      return (Number.isFinite(price) ? price : 0) *
        (Number.isFinite(quantity) ? quantity : 0);
    },
    // FILTERED RESULTS WHEN SEARCHING
    filteredCompanies() {
      if (this.companies.length) {
        return this.companies.filter(c => {
          return c.companyName
            .toLowerCase()
            .includes(this.searchCompanies.toLowerCase());
        });
      }
    },
    filteredProjects() {
      if (this.projects.length) {
        return this.projects.filter(p => {
          return p.projectName
            .toLowerCase()
            .includes(this.searchProjects.toLowerCase());
        });
      }
    },
    filteredObjects() {
      if (this.objects.length) {
        return this.objects.filter(o => {
          return o.objectName
            .toLowerCase()
            .includes(this.searchObjects.toLowerCase());
        });
      }
    },
    filteredParts() {
      if (this.parts.length) {
        return this.parts.filter(p => {
          return p.partName
            .toLowerCase()
            .includes(this.searchParts.toLowerCase());
        });
      }
    },
    filteredReporters() {
      if (this.reporters.length) {
        return this.reporters.filter(r => {
          return r.name
            .toLowerCase()
            .includes(this.searchReporters.toLowerCase());
        });
      }
    },
    filteredWorkers() {
      if (this.workers.length) {
        return this.workers.filter(w => {
          return w.name
            .toLowerCase()
            .includes(this.searchWorkers.toLowerCase());
        });
      }
    },
    // RESETS
    resetSelectedCompany() {
      this.inquiry.company = {
        _id: '',
        companyName: ''
      };
      this.company = '';
      delete this.queryObject.company;
      delete this.queryObject.companyName;
      this.resetSelectedProject();
    },
    resetSelectedProject() {
      this.inquiry.project = {
        _id: '',
        projectName: ''
      };
      this.project = '';
      delete this.queryObject.project;
      delete this.queryObject.projectName;
      this.resetSelectedObject();
    },
    resetSelectedObject() {
      this.inquiry.object = {
        _id: '',
        objectName: ''
      };
      this.object = '';
      delete this.queryObject.object;
      delete this.queryObject.objectName;
      this.resetSelectedPart();
    },
    resetSelectedPart() {
      this.resetReports();
      this.inquiry.part = {
        _id: '',
        partName: ''
      };
      this.part = '';
      delete this.queryObject.part;
      delete this.queryObject.partName;
    },
    resetSelectedReporter() {
      this.resetReports();
      this.inquiry.reporter = {
        _id: '',
        name: ''
      };
      this.reporter = '';
      delete this.queryObject.reporter;
      delete this.queryObject.reporterName;
    },
    resetSelectedWorker() {
      this.resetReports();
      this.inquiry.worker = {
        _id: '',
        name: ''
      };
      this.reporter = '';
      delete this.queryObject.worker;
      delete this.queryObject.workerName;
    },
    resetInquiry() {
      this.reports = [];
      this.isInquiryMade = false;
      this.resetSelectedCompany();
      if (
        this.getUser.permissions.isSuperAdmin ||
        this.getUser.permissions.isAdmin
      ) {
        this.resetSelectedReporter();
        this.resetSelectedWorker();
      }
      this.selectPriceStatus(null);
      this.changeDatePeriod('current');
      this.activeProjects = true;
      this.inquiry.isInvalid = false;
      this.inquiry.search = '';
    },
    resetReports() {
      this.reports = [];
      this.isInquiryMade = false;
    },
    // SELECTS
    selectCompany(c) {
      this.resetReports();
      this.inquiry.company = c;
      this.queryObject.company = c._id;
      this.queryObject.companyName = c.companyName;
    },
    selectProject(p) {
      this.resetReports();
      this.inquiry.project = p;
      this.queryObject.project = p._id;
      this.queryObject.projectName = p.projectName;
    },
    selectObject(o) {
      this.resetReports();
      this.inquiry.object = o;
      this.queryObject.object = o._id;
      this.queryObject.objectName = o.objectName;
    },
    selectPart(p) {
      this.resetReports();
      this.inquiry.part = p;
      this.queryObject.part = p._id;
      this.queryObject.partName = p.partName;
    },
    selectReporter(r) {
      this.resetReports();
      this.inquiry.reporter = r;
      this.queryObject.reporter = r._id;
      this.queryObject.reporterName = r.name;
    },
    selectWorker(w) {
      this.resetReports();
      this.inquiry.worker = w;
      this.queryObject.worker = w._id;
      this.queryObject.workerName = w.name;
    },
    selectInvalid() {
      this.resetReports();
      this.queryObject.isInvalid = this.inquiry.isInvalid;
    },
    selectActiveProjects() {
      this.resetReports();
      this.resetSelectedCompany();
      this.queryObject.active = this.activeProjects;
    },
    setDates(from, to) {
      const date = new Date();
      // set first day of previous month
      this.inquiry.fromDate = new Date(
        date.getFullYear(),
        date.getMonth() - from,
        1
      );
      this.inquiry.fromDate.setHours(0, 0, 0, 0);
      // set last day of previous month
      this.inquiry.toDate = new Date(
        date.getFullYear(),
        date.getMonth() + to * -1,
        0
      );
      this.inquiry.toDate.setHours(23, 59, 59, 999);
    },
    getTotals() {
      this.totalMaterialQuantity = 0;
      this.totalActivityQuantity = 0;
      this.totalMechanizationQuantity = 0;
      this.totalWorkersItems = 0;

      let materialsSum = 0;
      let activitiesSum = 0;
      let mechanizationsSum = 0;
      let workersSum = 0;

      if (this.reports.length) {
        this.reports.forEach(r => {
          this.diaryRows(r, 'buildingMaterials').forEach(m => {
            this.totalMaterialQuantity++;
            materialsSum += this.materialTotal(m);
          });
          if (r.activities) {
            r.activities.forEach(a => {
              this.totalActivityQuantity++;
              activitiesSum += +a.quantity * +a.price;
            });
          }
          if (r.mechanizations) {
            r.mechanizations.forEach(m => {
              this.totalMechanizationQuantity++;
              mechanizationsSum += +m.quantity * +m.price;
            });
          }

          for (let tag of ['materials', 'activities', 'mechanizations']) {
            if (r[tag]) {
              r[tag].forEach(x => {
                if (x.worker) {
                  this.totalWorkersItems++;
                  workersSum += +x.quantity * +x.price;
                }
              });
            }
          }
        });
      }

      this.totalWorkers = workersSum;
      this.totalMaterials = materialsSum;
      this.totalActivities = activitiesSum;
      this.totalMechanizations = mechanizationsSum;
    },
    // REQUESTS
    getCompanies() {
      let url = '';
      if (this.getUser.permissions.isAdmin) {
        url = `${process.env.VUE_APP_BASE_URI}/company/${this.activeProjects ? 'active' : 'inactive' }`;
      } else if (this.getUser.permissions.isReporter) {
        url = `${process.env.VUE_APP_BASE_URI}/company/reporters/companies/${this.getUser._id}`;
      } else {
        this.$snotify.error('Нямате достатъчно права!');
      }

      return this.$http
        .get(url)
        .then(response => {
          this.companies = response.data;
        })
        .catch(error => console.log(error));
    },
    getProjects() {
      this.projects = [];
      if (this.inquiry.company._id) {
        let url = '';

        if (this.getUser.permissions.isAdmin) {
          url = `${process.env.VUE_APP_BASE_URI}/company/project-names/${this.inquiry.company._id}?active=${this.activeProjects ? 'true' : 'false' }`;
        } else if (this.getUser.permissions.isReporter) {
          url = `${process.env.VUE_APP_BASE_URI}/company/reporters/projects/${this.inquiry.company._id}/${this.getUser._id}`;
        } else {
          this.$snotify.error('Нямате достатъчно права!');
        }

        return this.$http
          .get(url)
          .then(response => {
            this.projects = response.data;
          })
          .catch(error => console.log(error.response));
      }
    },
    getObjects() {
      this.objects = [];
      if (this.inquiry.project._id) {
        let url = '';

        if (this.getUser.permissions.isAdmin) {
          url = `${process.env.VUE_APP_BASE_URI}/company/object-names/${this.inquiry.company._id}/${this.inquiry.project._id}?active=${this.activeProjects ? 'true' : 'false' }`;
        } else if (this.getUser.permissions.isReporter) {
          url = `${process.env.VUE_APP_BASE_URI}/company/reporters/objects/${this.inquiry.company._id}/${this.inquiry.project._id}/${this.getUser._id}`;
        } else {
          this.$snotify.error('Нямате достатъчно права!');
        }

        return this.$http
          .get(url)
          .then(response => {
            this.objects = response.data;
          })
          .catch(error => console.log(error.response));
      }
    },
    getParts() {
      this.parts = [];
      if (this.inquiry.object._id) {
        let url = `${process.env.VUE_APP_BASE_URI}/company/part-names/${this.inquiry.company._id}/${this.inquiry.project._id}/${this.inquiry.object._id}`;
        return this.$http
          .get(url)
          .then(response => {
            this.parts = response.data;
          })
          .catch(error => console.log(error.response));
      }
    },
    getReporters() {
      this.reporters = [];
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/auth/users/reporters`)
        .then(response => {
          this.reporters = response.data;
          // console.log(this.reporters);
        });
    },
    getWorkers() {
      this.workers = [];
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/auth/users/workers`)
        .then(response => {
          this.workers = response.data;
        });
    },
    // if there are queries, load the existing parameters and assign them to the empty queryObject
    // TODO: refactor
    loadQueries(query) {
      if (Object.keys(query).length) {
        if (query.fromDate) {
          this.inquiry.fromDate = new Date(query.fromDate);
          this.queryObject.fromDate = query.fromDate;
        }
        if (query.toDate) {
          this.inquiry.toDate = new Date(query.toDate);
          this.queryObject.toDate = query.toDate;
        }
        if (query.company) {
          this.inquiry.company._id = query.company;
          this.queryObject.company = query.company;
        }
        if (query.companyName) {
          this.inquiry.company.companyName = query.companyName;
          this.queryObject.companyName = query.companyName;
        }
        if (query.project) {
          this.inquiry.project._id = query.project;
          this.queryObject.project = query.project;
        }
        if (query.projectName) {
          this.inquiry.project.projectName = query.projectName;
          this.queryObject.projectName = query.projectName;
        }
        if (query.object) {
          this.inquiry.object._id = query.object;
          this.queryObject.object = query.object;
        }
        if (query.objectName) {
          this.inquiry.object.objectName = query.objectName;
          this.queryObject.objectName = query.objectName;
        }
        if (query.part) {
          this.inquiry.part._id = query.part;
          this.queryObject.part = query.part;
        }
        if (query.partName) {
          this.inquiry.part.partName = query.partName;
          this.queryObject.partName = query.partName;
        }
        if (query.reporter) {
          this.inquiry.reporter._id = query.reporter;
          this.queryObject.reporter = query.reporter;
        }
        if (query.reporterName) {
          this.inquiry.reporter.name = query.reporterName;
          this.queryObject.reporterName = query.reporterName;
        }
        if (query.worker) {
          this.inquiry.worker._id = query.worker;
          this.queryObject.worker = query.worker;
        }
        if (query.workerName) {
          this.inquiry.worker.name = query.workerName;
          this.queryObject.workerName = query.workerName;
        }
        if (query.isInvalid) {
          const isInvalid = query.isInvalid == 'true' ? true : false;
          this.inquiry.isInvalid = isInvalid;
          this.queryObject.isInvalid = isInvalid;
        }
        if (query.active) {
          const active = query.active == 'true' ? true : false;
          this.activeProjects = active;
          this.queryObject.active = active;
        }
        if (query.tab) {
          this.selectTab(+query.tab);
        }
        if (query.period) {
          this.datePeriod = query.period;
          this.queryObject.period = query.period;
        }
        if (query.status) {
          this.selectPriceStatus(+query.status);
        }
        if (query.search) {
          this.inquiry.search = query.search;
        }

        this.getInquiry();
      }
    },
    getUrl() {
      // this.inquiry.search = this.inquiry.search.replace('/', '');

      let url = `${process.env.VUE_APP_BASE_URI}/report/inquiry`;
      url += `/${this.inquiry.company._id ? this.inquiry.company._id : 0}`;
      url += `/${this.inquiry.project._id ? this.inquiry.project._id : 0}`;
      url += `/${this.inquiry.object._id ? this.inquiry.object._id : 0}`;
      url += `/${this.inquiry.part._id ? this.inquiry.part._id : 0}`;
      url += `/${this.inquiry.reporter._id ? this.inquiry.reporter._id : 0}`;
      url += `/${this.inquiry.worker._id ? this.inquiry.worker._id : 0}`;
      url += `/${this.inquiry.fromDate.toISOString()}`;
      url += `/${this.inquiry.toDate.toISOString()}`;
      url += `/${this.inquiry.isInvalid}`;
      url += `/${this.activeProjects}`;
      url += `/${this.inquiry.priceStatus}`;
      url += `/${
        this.inquiry.search ? encodeURIComponent(this.inquiry.search) : null
      }`;
      return url;
    },
    getMDM() {
      this.$http.get(this.getUrl() + '?mdm=true').then(response => {
        this.mdm = response.data;
      });
    },
    checkPeriod() {
      const longPeriods = ["half", "year", "all"];

      if (longPeriods.includes(this.datePeriod)) {
        if (confirm('Сигурни ли сте, че искате да пуснете справка за толкова дълъг период? Това може да наруши работата на системата!')) {
          this.getInquiry();
        }
      } else {
        this.getInquiry();
      }
    },
    getInquiry() {
      this.$store.dispatch('startLoading');
      if (this.inquiry.search) {
        this.queryObject.search = this.inquiry.search;
      }
      this.$router.push({ query: this.queryObject });
      this.isInquiryMade = true;
      this.reports = [];

      this.$http.get(this.getUrl()).then(response => {
        this.reports = response.data;
        if (!this.$route.query.tab) {
          if (this.inquiry.worker._id) {
            this.activeTab = 4;
          } else {
            this.activeTab = 0;
          }
        }

        this.getTotals();

        this.$store.dispatch('stopLoading');
        // Scroll to inquiry
        this.isScrolled = true;
      });
    },
    // Scroll to the inquiry after click of the button "Направи справка"
    scrollToInquiry() {
      if (
        this.$refs['reports'] != undefined &&
        this.reports.length &&
        this.isScrolled
      ) {
        this.$refs['reports'].scrollIntoView({
          block: 'start',
          behavior: 'smooth'
        });
        this.isScrolled = false;
      } else if (
        this.$refs['no-reports'] != undefined &&
        !this.reports.length &&
        this.isScrolled
      ) {
        this.$refs['no-reports'].scrollIntoView({ behavior: 'smooth' });
        this.isScrolled = false;
      }
    },
    scrollToTop() {
      this.$refs['top'].scrollIntoView({ behavior: 'smooth' });
    },
    goToReport(id) {
      this.$router.push(`/reports/edit/${id}`);
    }
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  mounted() {
    this.setDates(0, -1);
    this.loadQueries(this.$route.query);

    if (
      !this.getUser.permissions.isAdmin &&
      this.getUser.permissions.isReporter
    ) {
      this.selectReporter({
        name: this.getUser.name,
        _id: this.getUser._id
      });
    }
  },
  updated() {
    this.scrollToInquiry();
  }
};
</script>

<style scoped>
.inquiry {
  padding: 10px 40px;
}
.inquiry-header {
  align-items: center;
  display: flex;
  height: 36px;
  justify-content: space-between;
}
.inquiry-header-controlls {
  align-items: center;
  display: flex;
}
.inquiry-pre-datepicker-text {
  color: #373737;
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  margin-right: 20px;
}
.inquiry-datepicker {
  border-radius: 4px;
  display: flex;
  position: relative;
  width: 330px;
  padding: 10px 0;
}
.inquiry-datepicker .new-input-wrapper {
  background-color: #ece9d8;
  margin: 0;
  width: 50%;
}
.inquiry-datepicker .new-input-wrapper:first-child {
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
}
.inquiry-datepicker .new-input-wrapper:nth-child(2) {
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
}
.inquiry-datepicker .new-input {
  background-color: transparent;
  margin: 0;
}
.inquiry-datepicker .new-input input {
  background-color: transparent;
  border: 1px solid #ece9d8;
  height: 36px;
  cursor: pointer;
}
.inquiry-datepicker .new-input input:focus {
  background-color: #fff;
  border: 1px solid #d8d2bd;
}
.inquiry-datepicker .datepicker-dropdown {
  /* background-color: #ccd1e3; */
}
.inquiry-header-controlls .btns {
  align-items: center;
}
.inquiry-filters {
  background-color: #ece9d8;
  border-radius: 4px;
  margin-top: 10px;
  padding: 25px 25px 15px;
}
.inquiry-filters-inputs {
  display: flex;
}
.inquiry-filters-inputs .new-input-wrapper:last-child {
  margin-right: 0;
}
.inquiry-filters-btns {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
  position: relative;
}
.inquiry-filters-btns .checkboxes {
  display: flex;
}
.checkboxes-wrapper {
  display: flex;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
}
.inquiry-filters-btns .checkbox-wrapper {
  margin-left: 0;
  margin-right: 15px;
}
.checkbox-wrapper .checkmark {
  background-color: #f4f4f4;
}
.checkbox-wrapper:hover input ~ .checkmark {
  background-color: #fff;
}
.checkbox-wrapper:hover input:checked ~ .checkmark {
  background-color: #a7430e;
}
.inquiry-filters-btns .btn {
  margin: 0;
}
.inquiry-filters-btns .btn-excel {
  margin-right: 10px;
}
/* CONTENT */
.reports-tabs {
  display: flex;
  font-weight: 700;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: -1px;
  position: relative;
}
.reports-tab {
  align-items: center;
  background-color: #ece9d8;
  border: none;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  cursor: pointer;
  flex: 1;
  font-weight: 700;
  display: flex;
  height: 45px;
  justify-content: center;
  margin: 0 3px;
  -webkit-transition: background-color 0.3s;
  -moz-transition: background-color 0.3s;
  -ms-transition: background-color 0.3s;
  -o-transition: background-color 0.3s;
  transition: background-color 0.3s;
  width: auto;
}
.reports-tab span:first-child {
  margin-right: 2px;
}
.reports-tab:first-child {
  margin-left: 0;
}
.reports-tab:last-child {
  margin-right: 0;
}
.reports-tab:hover {
  background-color: #d8d2bd;
}
.reports-tab-active {
  background-color: #fff;
  border: 1px solid #ccd1e3;
  border-bottom: 1px solid #fff;
}
.reports-tab-active:hover {
  background-color: #fff;
}
.reports-content {
  background-color: #fff;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border: 1px solid #ccd1e3;
  padding: 0 10px;
}
.reports-content .table tbody tr {
  background-color: #fbfaf5;
}
.reports-content .table tbody td {
  padding: 10px;
}
.reports-content .table .td-company-name {
  position: relative;
  padding: 0 20px;
}
.reports-content .table tbody .tr-invalid {
  background-color: #fff8f8;
}
.reports-content .table tbody tr:hover {
  background-color: #ece9d8;
}
.reports-content .table tbody .sum-row {
  background-color: transparent;
  font-size: 18px;
  font-weight: 700;
}
.reports-content .table tbody .sum-row td:first-child {
  padding-right: 30px;
  text-align: right;
}
.inquiry-title-wrapper {
  padding: 30px 20px 20px;
}
.inquiry-title {
  color: #8d3506;
  font-size: 18px;
  font-weight: 400;
  text-align: center;
  width: 100%;
}
.inquiry-title-invalid {
  color: #bf392a;
}
.no-reports {
  /* background-color: #fff; */
  /* border-radius: 4px; */
  padding: 20px;
  text-align: center;
  width: 100%;
}
.td-center {
  text-align: center;
}
.table-wrapper {
  overflow: auto;
}
.date-toggles,
.flag-toggles {
  align-items: center;
  display: flex;
}
.date-toggle,
.flag-toggle {
  align-items: center;
  background-color: #ece9d8;
  border: 1px solid #ece9d8;
  border-radius: 4px;
  color: #8d3506;
  cursor: pointer;
  font-size: 24px;
  display: inline-flex;
  height: 36px;
  justify-content: center;
  margin-left: 10px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: 36px;
}
.flag-toggles p {
  margin-right: 10px;
}
.flag-toggle img {
  width: 24px;
}
.date-toggle:hover,
.flag-toggle:hover {
  border-color: rgba(141, 53, 6, 0.2);
}
.date-toggle-active,
.flag-toggle-active,
.date-toggle-active:hover,
.flag-toggle-active:hover {
  background-color: #ffe0b2;
  border-color: #8d3506;
}
.desktop {
  /* display: flex; */
}
.mobile {
  display: none;
}

/* Responsive */
@media screen and (max-width: 1200px) {
  .checkboxes-wrapper {
    position: static;
    transform: initial;
  }
}
@media screen and (max-width: 1000px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: inline-grid;
  }
  .inquiry {
    padding: 10px 15px;
  }
  .inquiry-header {
    height: initial;
  }
  .inquiry-header-controlls {
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
    width: 100%;
  }
  .date-toggle {
    margin: 0 5px;
  }
  .inquiry-pre-datepicker-text {
    font-size: 20px;
  }
  .inquiry-filters-inputs {
    display: flex;
    flex-direction: column;
  }
  .inquiry-filters-btns {
    flex-direction: column;
  }
  .inquiry-filters-btns .btn {
    margin-top: 10px;
  }
  .inquiry-datepicker {
    margin-top: 10px;
    padding: 2px 0;
    width: 100%;
  }
  .new-input-wrapper {
    width: 100%;
  }
  .checkboxes-wrapper {
    margin: 5px 0;
  }
  .table-wrapper {
    overflow: auto;
  }
  .new-content-data-item-toggle-circle {
    height: 50px;
    width: 50px;
  }
  .new-content-data-item-toggle-circle.mobile {
    bottom: 20px;
    cursor: pointer;
    position: fixed;
    right: 20px;
  }
  .new-content-data-item-toggle-circle.mobile.excel {
    background-color: green;
    bottom: 75px;
    cursor: pointer;
    position: fixed;
    right: 20px;
  }
  .new-content-data-item-toggle-circle.mobile.top {
    background-color: #083f75;
    margin-top: 50px;
    position: inherit;
  }
  .new-content-data-item-toggle-circle .sienit {
    border: 0px;
    font-size: 20px;
  }
  .modal-footer {
    background-color: #fff;
    height: 125px;
    padding: 0px;
  }
  .no-wrap {
    white-space: nowrap;
  }
  @media screen and (max-width: 600px) {
    .reports-tab {
      flex-direction: column;
    }
    .reports-tab span:first-child {
      margin: 0;
    }
  }
  @media screen and (max-width: 380px) {
    .reports-tab {
      font-size: 12px;
    }
    .checkboxes-wrapper {
      flex-direction: column;
    }
  }
}
</style>
